import type { Filters, FilterKey } from '../types/FiltersSchema';

export function parseQueryParams(searchParams: URLSearchParams): Filters {
  const filters = {} as Filters;

  for (const [key, value] of searchParams.entries()) {
    filters[key as FilterKey] = value;
  }

  return filters;
}
